<template>
  <div>
    <v-toolbar color="primary" fixed dark app class="full-nav">
      <!-- <v-toolbar-title class="ml-0 hidden-md-and-up">
      <v-menu offset-y origin="center center" :nudge-bottom="10">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list class="pa-0">
          <v-list-tile
            v-for="(item, index) in navItems"
            :key="index"
            :to="item.url"
            ripple="ripple"
            rel="noopener"
          >
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      </v-toolbar-title>-->
      <v-toolbar-title class="ml-0">
        <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
      </v-toolbar-title>
      <v-toolbar-title class="ml-0">
        <span>Vietmap Motrak</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-lg-and-up hidden-sm-and-down">
        <template v-for="(item,index) in navItems" >
        <v-btn :key="index" flat :to="item.url" v-if="item.isAccess">{{item.title}}</v-btn>
        </template>
      </v-toolbar-items>
      <!-- <v-menu offset-y origin="center center" :nudge-bottom="10">
        <v-btn icon large flat slot="activator">
          <v-avatar size="30px">
            <img src="/static/avatar/no-avatar.png" alt="Michael Wang">
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            v-for="(item,index) in menuItems"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>-->

      <all-applications />

      <v-menu offset-y origin="center center" :nudge-bottom="16" :nudge-right="12">
        <v-toolbar-title class="ml-0" slot="activator">
          <span>
            <small>
              {{loggedUser && loggedUser.phone}}
              <v-icon>expand_more</v-icon>
            </small>
          </span>
        </v-toolbar-title>
        <v-list class="pa-0">
          <v-list-tile @click="profileDialog = true" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Tài khoản</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="showLogs()" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>error</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logs</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>fullscreen_exit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Đăng xuất</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div class="text-xs-center">
      <v-dialog v-model="profileDialog" width="500">
        <v-card>
          <profile @show="profileDialog = $event"/>
        </v-card>
      </v-dialog>
    </div>

    <dialog-logs ref="dialogLogs"/>
  </div>
</template>

<script>
import Util from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import Profile from '@/pages/account/components/profile';
import menu from '@/api/menu';
import AllApplications from '@/components/AllApplications';
import DialogLogs from '@/components/dialog/DialogLogs';

export default {
  name: 'app-toolbar',
  components: {
    Profile,
    AllApplications,
    DialogLogs
  },
  data: () => ({
    menuItems: [
      {
        icon: 'person',
        title: 'Phone',
        click: e => {}
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Đăng xuất',
        click: e => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
    navItems: menu,
    profileDialog: false
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    ...mapGetters(['loggedUser'])
  },
  mounted () {
    this.menuItems[0].title = this.loggedUser ? this.loggedUser.phone : '';
  },
  methods: {
    ...mapActions(['getUserInfo']),
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    logout () {
      window.getApp.$emit('APP_LOGOUT');
    },

    showLogs () {
      this.$refs.dialogLogs.open();
    }
  }
};
</script>

<style lang="stylus" scoped>
.full-nav {
  padding-left: 0 !important;
  z-index: 1000;
}

.hambuger-button {
  margin-left: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue